// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"2976b7aa","266":"7228b74f","779":"22a2c4ff"}[chunkId] + ".chunk.css";
};